import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

const HeaderContainer = styled.header`
  padding: 2rem 1.5rem 1rem;
  text-align: center;
`;

const ArtistName = styled.h1`
  font-family: "kepler-std-display", serif;
  font-weight: 700;
  font-style: italic;
  font-size: 2.2rem;
  letter-spacing: 0.02em;
  color: var(--text-primary);
  margin: 0 0 1.5rem 0;

  @media (min-width: 768px) {
    font-size: 3rem;
  }
`;

const Nav = styled.nav`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 0.5rem 1.5rem;
  font-size: 0.75rem;
  letter-spacing: 0.15em;
  text-transform: uppercase;

  a {
    color: var(--text-muted);
    text-decoration: none;
    padding: 0.5rem 0;
    transition: color 0.2s ease;

    &:hover {
      color: var(--accent);
    }
  }

  @media (min-width: 768px) {
    gap: 0.5rem 2rem;
    font-size: 0.8rem;
  }
`;

export default function Header() {
    return (
        <HeaderContainer>
            <Link to="/" style={{ textDecoration: 'none' }}>
                <ArtistName>ben kamen</ArtistName>
            </Link>

            <Nav>
                <Link to="/">Home</Link>
                <a href="http://benkamen.bandcamp.com" target="_blank" rel="noreferrer">Music</a>
                <a href="http://www.olympianoiseco.com" target="_blank" rel="noreferrer">Apps</a>
                <a href="http://www.instagram.com/benkamen" target="_blank" rel="noreferrer">Instagram</a>
                <Link to="/history">History</Link>
                <a href="https://aemail.com/8q1j">Contact</a>
            </Nav>
        </HeaderContainer>
    );
}
